function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueZagination = e() : t.VueZagination = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var r = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        n.d(i, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 0);
  }([function (t, e, n) {
    "use strict";

    n.r(e);
    n(1);
    var i = {
      props: {
        current: [Number, Object],
        total: Number,
        custom_options: Object
      },
      data: function data() {
        return {
          options: Object.assign({
            central_max: 2,
            side_max: 3,
            is_prev_next: !0,
            is_first_last: !0,
            is_hide_one: !0
          }, this.custom_options || {})
        };
      },
      computed: {
        valid_current: function valid_current() {
          return null == this.current ? 1 : (t = "number" == typeof this.current ? this.current : parseInt(this.current), isNaN(t) ? 1 : t);
          var t;
        },
        valid_total: function valid_total() {
          return null == this.total ? 1 : (t = "number" == typeof this.total ? this.total : parseInt(this.total), isNaN(t) ? 1 : t);
          var t;
        },
        pages: function pages() {
          for (var t = [], e = 1; e <= this.options.side_max; e++) {
            1 <= e && e <= this.valid_total && t.push(e);
          }

          for (var n = this.valid_current - this.options.central_max; n <= this.valid_current + this.options.central_max; n++) {
            1 <= n && n <= this.valid_total && t.push(n);
          }

          for (var i = this.valid_total - this.options.side_max + 1; i <= this.valid_total; i++) {
            1 <= i && i <= this.valid_total && t.push(i);
          }

          return t = t.filter(function (t, e, n) {
            return n.indexOf(t) === e;
          }), t;
        },
        pagination: function pagination() {
          for (var t = [], e = 0, n = this.pages.length; e < n; e++) {
            var i = this.pages[e];
            e > 0 && i - this.pages[e - 1] > 1 && t.push({
              is_separator: !0
            }), t.push({
              is_separator: !1,
              number: i,
              is_active: i == this.valid_current
            });
          }

          return t;
        },
        prev: function prev() {
          return this.valid_current > 1 ? this.valid_current - 1 : 1;
        },
        next: function next() {
          return this.valid_current < this.valid_total ? this.valid_current + 1 : this.valid_total;
        },
        is_first_page: function is_first_page() {
          return !!(this.options.is_first_last && this.valid_current > 1);
        },
        is_prev_page: function is_prev_page() {
          return !!(this.options.is_prev_next && this.valid_current > 1);
        },
        is_next_page: function is_next_page() {
          return !!(this.options.is_prev_next && this.valid_current < this.valid_total);
        },
        is_last_page: function is_last_page() {
          return !!(this.options.is_first_last && this.valid_current < this.valid_total);
        }
      },
      methods: {},
      template: '\n    <div class="vue-zagination" v-if="!options.is_hide_one || valid_total > 1">\n      <a\n        href=""\n        v-if="is_first_page"\n        class="page"\n        @click.prevent="$emit(\'zagination_click\', 1)"\n      ><<</a>\n      <a\n        href=""\n        v-if="is_prev_page"\n        class="page"\n        @click.prevent="$emit(\'zagination_click\', prev)"\n      ><</a>\n      <template v-for="item in pagination">\n        <span v-if="item.is_separator" class="separator">…</span>\n        <span v-else-if="item.is_active" class="page active">{{ item.number }}</span>\n        <a\n          v-else\n          href=""\n          class="page"\n          @click.prevent="$emit(\'zagination_click\', item.number)"\n        >{{ item.number }}</a>\n      </template>\n      <a\n        href=""\n        v-if="is_next_page"\n        class="page"\n        @click.prevent="$emit(\'zagination_click\', next)"\n      >></a>\n      <a\n        href=""\n        v-if="is_last_page"\n        class="page"\n        @click.prevent="$emit(\'zagination_click\', valid_total)"\n      >>></a>\n    </div>\n  '
    };
    e["default"] = i;
  }, function (t, e, n) {}]);
});